import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.582 2.998a2 2 0 0 1 2.829 0l6.586 6.586a2 2 0 0 1 0 2.828L12.415 28.994a2 2 0 0 1-2.829 0l-6.585-6.586a2 2 0 0 1 0-2.829zm8 8-6.585-6.586-3.085 3.085 3.295 3.296a1 1 0 0 1-1.414 1.414l-3.296-3.296-3.085 3.086 3.295 3.296a1 1 0 0 1-1.414 1.414l-3.296-3.296-3.085 3.086 3.295 3.296a1 1 0 0 1-1.414 1.414l-3.296-3.296-3.082 3.083L11 27.58z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconTakeoffs = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTakeoffs);
export default Memo;
